<video #video
        width=100%
        height={{playerStyle.height}}
        poster="/assets/layout/images/player-poster.png"
        controls>
</video>
